import Api from '../Api'
import { NEW_POPUP } from './types'

export const updateProductInHurton = (/** @type String} */ sku) => dispatch => {
    Api.updateProductInHurton(sku)
        .then(_ => {
            dispatch({
                type: NEW_POPUP,
                text: 'Zaktualizowano produkt na Hurtonie',
                severity: 'success',
            })
        })
        .catch(error => {
            console.error(error)

            dispatch({
                type: NEW_POPUP,
                text: 'Nie udało się zaktualizować na Hurtonie',
                severity: 'error',
            })
        })
}
